/* src/locations/cards/LocationCard/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 90,
    width: '100%',
    overflow: 'auto',
  },
});



// WEBPACK FOOTER //
// ./src/modules/locations/cards/LocationCard/styles.js